import { useContext } from 'react';
import { useIsMobile } from '~/context/common/DeviceContext';
import { useShowComposerTreatment } from '~/context/composer/ComposerContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import useAlertStatus from './useAlertStatus';
import useIsOnHold from './useIsOnHold';
import useShowOutOfAreaError from './useShowOutOfAreaError';

export default function useShowComposerAvailabilityNotice() {
  const isMobile = useIsMobile();
  const showComposerTreatment = useShowComposerTreatment();
  const { purchasePending } = useAlertStatus();
  const { isSubscribedToNotifications } = useContext(UserVehicleContext);
  const isOnHold = useIsOnHold();
  const showOutOfAreaError = useShowOutOfAreaError();

  const showOnHold =
    isOnHold && purchasePending && !isSubscribedToNotifications;

  return (
    showComposerTreatment && isMobile && (showOutOfAreaError || showOnHold)
  );
}
